import React, { PureComponent } from 'react';
import moment from 'moment';

import {
  defaultDateFilters,
  seoDateFilters,
  fetchFilterData,
  isDesktopDevice,
  isFilterExpired,
  localstorageAvailable,
  updateDateRange
} from '../../../../services/services';
import { history, historyService } from '../../../../services/history';
import { T } from '../../../../../../common/locale/translate';

import Accommodations from '../../../../common/components/accommodations';
import Adults from '../../../../common/components/adults';
import Alimentation from '../../../../common/components/alimentation';
import Children from '../../../../common/components/children';
import DatePicker from '../../../../common/components/datepicker';
import Destination from '../../../../common/components/destination';
import Facilities from '../../../../common/components/facilities';
import FlightAirport from '../../../../common/components/flight-airport';
import FlightType from '../../../../common/components/flight-type';
import HotelName from '../../../../common/components/hotel_name';
import HotelStandard from '../../../../common/components/hotel_standard';
import Operators from '../../../../common/components/operators';
import Panel from '../../../../common/components/panel';
import PersonPrice from '../../../../common/components/person_price';
import TripLength from '../../../../common/components/trip-length';
import { scrollIt } from '../../../../services/animate';
import Transfer from '../../../../common/components/transfer';

export default class AdvancedSearchForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      url: '',
      unlisten: () => {},
      startDate: props.params.dates_offset
        ? seoDateFilters(props.params).from
        : props.params.departure_date || defaultDateFilters().from,
      endDate: props.params.dates_delta
        ? seoDateFilters(props.params).to
        : props.params.return_date || defaultDateFilters().to,
      duration: { default: {} },
      alimentations: [],
      filterDataCacheTime: 259200000,
      default_activity: {
        departure_airports: true,
        duration: true,
        flight_type: true,
        operators: true,
        price_max_eur: true,
        accommodations: true,
        boards: true,
        rating_min: true,
        facilities: true,
        hotel_name: true,
        transfer: true
      },
      activity: {
        departure_airports: true,
        duration: true,
        flight_type: true,
        operators: true,
        price_max_eur: true,
        boards: true,
        accommodations: true,
        rating_min: true,
        facilities: true,
        hotel_name: true,
        transfer: true
      },
      params: {
        ...props.params
      }
    };
    this.state.durationMin = this.state.params
      ? this.state.params.duration_min
      : 7;
    this.state.returnDateRangeStart = moment
      .unix(this.state.startDate)
      .add(this.state.durationMin, 'days');
  }

  componentDidMount() {
    if (typeof history() == 'undefined') {
      historyService.createComponentHistory();
    }
    const unlisten = historyService.listener(this.handleHistoryChange);
    this.changeActivityStates(this.state.params.offer_type);
    this.setInitialData();
    this.setState({ unlisten });
  }

  componentWillUnmount() {
    document.removeEventListener(
      'click',
      this.handleClickOutside.bind(this),
      true
    );
    this.state.unlisten();
  }

  render() {
    return (
      <div className="search">
        <div className="mobile-action-wrapper sticky-filters-tab">
          {T('offers_list').toUpperCase()}
          <button
            onClick={this.handleMobileToggle}
            className="mobile-filter-button"
          >
            <i className="fa fa-sliders" aria-hidden="true" />Filtruj wyniki
          </button>
        </div>
        <div className="search-form-outside-wrapper">
          <div className="mobile-header-wrapper">
            <h3 className="mobile-header">
              {' '}
              {T('filter_results')}{' '}
              <i
                className="fa fa-times mobile-toggle-switch"
                aria-hidden="true"
                onClick={this.handleMobileToggle}
              />{' '}
            </h3>
          </div>
          <div className="search-form-inside-wrapper">
            <Panel
              title={T('base_data')}
              className="basic-filters"
              active={true}
              search={this.handleSearch}
            >
              <div className="inner-wrapper">
                <FlightAirport
                  title={T('departure_from')}
                  ref="departure_airports"
                  filter_active={this.state.activity.departure_airports}
                  departure_airports={this.state.params.departure_airports}
                />

                <Destination
                  title={T('trip_direction')}
                  ref="regions"
                  regions={this.state.params.regions}
                />

                <HotelName
                  title={T('hotel_name_filter')}
                  ref="hotel_name"
                  hotel_name={this.state.params.hotel_name}
                  filter_active={this.state.activity.hotel_name}
                />

                <DatePicker
                  title={T('travel_departure')}
                  ref="departure_date"
                  className="date-from"
                  onChange={this.updateDates.bind(this, 'startDate')}
                  date={this.state.startDate}
                  startDate={this.state.startDate}
                  endDate={this.state.endDate}
                  name="departure_date"
                  selectsStart
                  withPortal={!isDesktopDevice()}
                />

                <DatePicker
                  title={T('travel_arrival')}
                  ref="return_date"
                  className="date-to"
                  onChange={this.updateDates.bind(this, 'endDate')}
                  date={this.state.endDate}
                  startDate={this.state.startDate}
                  endDate={this.state.endDate}
                  name="return_date"
                  selectsEnd
                  withPortal={!isDesktopDevice()}
                  minDate={this.state.returnDateRangeStart}
                />

                <TripLength
                  title={T('travel_time_period')}
                  ref="duration"
                  filter_active={this.state.activity.duration}
                  duration_min={this.state.params.duration_min}
                  duration_max={this.state.params.duration_max}
                  duration={this.state.duration}
                  on_change_duration={this.updateDuration.bind(this)}
                />

                <Adults
                  title={T('adults_count_filter')}
                  ref="adults_number"
                  adults_number={this.state.params.adults_number}
                />

                <Children
                  title={T('children_count_filter')}
                  ref="children_ages"
                  children_ages={this.state.params.children_ages}
                />
              </div>
              <div className="action-wrapper">
                <button onClick={this.handleSearch} className="search-button">
                  <i className="fa fa-search" /> {T('look_for')}
                </button>
              </div>
            </Panel>

            <Panel
              title="Lot"
              className="flight-type-filter"
              active={this.state.activity.flight_type}
              search={this.handleSearch}
            >
              <FlightType
                ref="flight_type"
                offer_type={this.state.params.offer_type}
                changeActivityStates={this.changeActivityStates}
              />
            </Panel>
            <Panel
              title={T('transfer_title')}
              className="accommodation-filter"
              active={this.state.activity.transfer}
              search={this.handleSearch}
            >
              <Transfer
                ref="transfer"
                transfer_values={this.state.params.transfer}
              />
            </Panel>
            <Panel
              title={T('price_per_person')}
              className="person-price-filter"
              active={this.state.activity.price_max_eur}
              search={this.handleSearch}
            >
              <PersonPrice
                title={T('maximal_price_eur')}
                ref="price_max_eur"
                price_max_eur={this.state.params.price_max_eur}
              />
            </Panel>

            <Panel
              title={T('board')}
              className="alimentation-filter"
              active={this.state.activity.boards}
              search={this.handleSearch}
            >
              <Alimentation
                title={T('board')}
                ref="boards"
                boards={this.state.params.boards}
                alimentations={this.state.alimentations}
              />
            </Panel>

            <Panel
              title={T('accommodation')}
              className="accommodation-filter"
              active={this.state.activity.accommodations}
              search={this.handleSearch}
            >
              <Accommodations
                withMobileTitle
                title={T('accommodation')}
                ref="accommodations"
                accommodations={this.state.params.accommodations}
              />
            </Panel>

            <Panel
              title={T('hotel_standard')}
              className="hotel-standard-filter"
              active={this.state.activity.rating_min}
              search={this.handleSearch}
            >
              <HotelStandard
                withMobileTitle
                title={T('hotel_standard_from')}
                ref="rating_min"
                rating_min={this.state.params.rating_min}
              />
            </Panel>

            <Panel
              title={T('facilities')}
              className="facilities-standard-filter"
              active={this.state.activity.facilities}
              search={this.handleSearch}
            >
              <Facilities
                title={T('facilities')}
                ref="facilities"
                facilities={this.state.params.facilities}
              />
            </Panel>

            <Panel
              title={T('operator')}
              className="provider-filter"
              active={this.state.activity.operators}
              search={this.handleSearch}
            >
              <Operators
                title={T('operator_name')}
                ref="operators"
                offer_type={this.state.params.offer_type}
                operators={this.state.params.operators}
              />
            </Panel>

            <div className="action-wrapper">
              <button onClick={this.handleSearch} className="search-button">
                <i className="fa fa-search" /> {T('look_for')}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  setInitialData = () => {
    if (localstorageAvailable()) {
      if (isFilterExpired('default', this.state.filterDataCacheTime)) {
        this.updateFilterSource();
      } else {
        const filter_data = JSON.parse(localStorage.getItem('default_filter'));
        this.setState({
          duration: filter_data.duration,
          alimentations: filter_data.alimentations_list
        });
      }
    } else {
      this.updateFilterSource();
    }
  };

  updateFilterSource = () => {
    fetchFilterData('default_filter').then(
      response => {
        const filter_data = response.data;
        if (localstorageAvailable()) {
          localStorage.setItem('default_filter', JSON.stringify(filter_data));
          localStorage.setItem(
            'default_filter_last_update',
            new Date().getTime()
          );
        }
        this.setState({
          duration: filter_data.duration,
          alimentations: filter_data.alimentations_list
        });
      },
      error => {
        console.log('Error when fetching default filter', error);
      }
    );
  };

  handleHistoryChange = (_, params) => {
    params = params['offer_type'] ? params : this.props.params;
    this.changeActivityStates(params['offer_type']);
  };

  updateDates = (name, date) => {
    this.setState(
      updateDateRange(name, date, {
        startDate: this.state.startDate,
        endDate: this.state.endDate
      }),
      () =>
        this.setState({
          returnDateRangeStart: moment
            .unix(this.state.startDate)
            .add(this.state.durationMin, 'days')
        })
    );
  };

  updateDuration = duration => {
    this.setState({
      durationMin: duration.min,
      returnDateRangeStart: moment
        .unix(this.state.startDate)
        .add(duration.min, 'days')
    });
  };

  handleMobileToggle = () => {
    if (document) {
      document.body.classList.toggle('modal-visible');
      document
        .getElementsByClassName('search-form-outside-wrapper')[0]
        .classList.toggle('active');
    }
  };

  changeActivityStates = offer_type => {
    const activities = {
      A: {
        ...this.state.default_activity,
        flight_type: false
      },
      S: {
        ...this.state.default_activity,
        departure_airports: false,
        flight_type: false
      },
      C1: {
        ...this.state.default_activity,
        duration: false,
        boards: false,
        rating_min: false,
        facilities: false,
        hotel_name: false,
        accommodations: false
      },
      C2: {
        ...this.state.default_activity,
        boards: false,
        rating_min: false,
        facilities: false,
        hotel_name: false,
        accommodations: false
      },
      GROUP: {
        ...this.state.default_activity,
        flight_type: false
      }
    };
    const params = {
      ...this.state.params,
      offer_type
    };
    const type =
      offer_type && offer_type.toUpperCase ? offer_type.toUpperCase() : 'A';
    this.setState({ activity: activities[type], params });
  };

  handleSearch = () => {
    scrollIt(0, 800, 'easeOutCubic');
    let temp = {},
      key,
      value;
    if (!isDesktopDevice()) {
      this.handleMobileToggle();
    }
    Object.keys(this.refs).map(v => {
      key = v;
      value = this.refs[v].returnSearchedValue();
      // add to url if current filter is active
      if (value && this.state.activity[key] !== false) {
        switch (key) {
          case 'duration': {
            temp['duration_min'] = value.min;
            temp['duration_max'] = value.max;
            break;
          }
          case 'flight_type': {
            temp['offer_type'] = value;
            break;
          }
          default: {
            temp[key] = value;
          }
        }
      }
    });
    // TODO add custom prefix names and change switch to sth better
    if (!temp['offer_type']) {
      temp['offer_type'] = this.state.params.offer_type
        ? this.state.params.offer_type
        : 'A';
    }
    if (temp['offer_type'] === 'GROUP') {
      temp['offer_type'] = 'A';
    }
    history().push({
      pathname: '/offers',
      search: `?${historyService.parseObject2Params(temp)}`
    });
  };
}



// WEBPACK FOOTER //
// ./app/javascript/pages/offers/components/advanced_search/index.js